export default __webpack_public_path__ + "static/media/Category.58d87f43.svg";